import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { TrialService } from '../services/trial.service';
import { EProduto } from '@shared/contracts/enums/produto.enum';

const MODULOS_ADICIONAIS_PRODUTOS = [EProduto.SAUDE];

@Injectable({
    providedIn: 'root'
})
export class ModulosAdicionaisGuard {

    private readonly _trialService = inject(TrialService);
    private readonly _router = inject(Router);

    canActivate(): boolean | UrlTree {
        const temModuloAdicional = MODULOS_ADICIONAIS_PRODUTOS.some(
            produtoId => this._trialService.getStatus(produtoId) === 'ACQUIRED'
        );

        if (temModuloAdicional) {
            return true;
        }
        return this._router.createUrlTree(['/pagina-indisponivel']);
    }
}
